import angular from 'angular';

/* global window, document, URL, Blob */

export default function EditSupportTicketDialogController(
  ssDialogService,
  alerts,
  loaderService,
  supportSharedModelService,
  addSupportTicketAttachmentDialog,
  addSupportTicketNoteDialog
) {
  const vm = this;

  vm.ticketCopy = null;
  vm.canAddTicket = true; // TODO: I'm guessing this isn't supposed to be a hard-coded value?
  vm.file = null;

  vm.handleFileAdd = handleFileAdd;
  vm.handleChangeContact = handleChangeContact;
  vm.handleChangePriority = handleChangePriority;
  vm.handleDownloadAttachmentClick = handleDownloadAttachmentClick;

  vm.handleAddNote = handleAddNote;
  vm.handleAddAttachment = handleAddAttachment;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSaveDialog = handleSaveDialog;

  _activate();

  /** ***************************************
   * Event Handlers
   */

  // eslint-disable-next-line no-unused-vars
  function handleFileAdd($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    vm.progress = 0;
  }

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleSaveDialog(form) {
    if (form.$valid) {
      loaderService.showViewLoader = true;
      _saveTicket()
        .then(() => {
          loaderService.showViewLoader = false;
          if (vm.refreshTicket) {
            vm.refreshTicket();
          }
          _closeDialog();
        })
        .catch((err) => {
          alerts.error(err);
        });
    }
  }

  function handleChangeContact() {
    supportSharedModelService.getContact(vm.ticketCopy.contactId)
      .then((contact) => {
        vm.ticketCopy.contactName = contact.name;
        vm.ticketCopy.contactPhone = contact.phone;
        vm.ticketCopy.contactEmail = contact.email;
      })
      .catch((err) => {
        alerts.error(err);
      });
  }

  function handleChangePriority() {
    angular.forEach(vm.displayList.priorityList, (priority) => {
      if (priority.id === vm.ticketCopy.priorityId) {
        vm.ticketCopy.priorityDescription = priority.description;
      }
    });
  }

  function handleDownloadAttachmentClick(event) {
    const attachmentId = event.target.id;
    supportSharedModelService.getTicketAttachment(attachmentId)
      .then((ticketAttachment) => {
        const d = supportSharedModelService.base64ToArrayBuffer(ticketAttachment.data);
        // const byteArray = new Uint8Array(ticketAttachment);

        const blob = new Blob(
          [d],
          { type: ticketAttachment.mimeType, }
        );
        // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, ticketAttachment.info.title);
        } else {
          const anchor = document.createElement('a');
          document.body.appendChild(anchor);
          anchor.setAttribute('type', 'hidden');

          anchor.href = URL.createObjectURL(blob);
          anchor.download = ticketAttachment.info.title;
          anchor.target = '_blank';
          anchor.click();
        }
      });
  }

  function handleAddNote($event) {
    ssDialogService.dialogs.support.addSupportTicketNoteDialog = ssDialogService.alert(
      addSupportTicketNoteDialog.getOptions($event, {
        ticketType: vm.ticketType,
        ticket: vm.ticket,
        displayList: vm.displayList,
        refreshTicket: vm.refreshTicket
      })
    );
    ssDialogService.show(ssDialogService.dialogs.support.addSupportTicketNoteDialog);
  }

  function handleAddAttachment($event) {
    ssDialogService.dialogs.support.addSupportTicketAttachmentDialog = ssDialogService.alert(
      addSupportTicketAttachmentDialog.getOptions($event, {
        ticketType: vm.ticketType,
        ticket: vm.ticket,
        displayList: vm.displayList,
        refreshTicket: vm.refreshTicket
      })
    );
    ssDialogService.show(ssDialogService.dialogs.support.addSupportTicketAttachmentDialog);
  }

  /** ***************************************
   * Private Functions
   */

  function _activate() {
    vm.ticketCopy = angular.copy(vm.ticket);
    if (!vm.displayList) {
      supportSharedModelService.getDisplayLists()
        .then((displayLists) => {
          vm.displayList = displayLists;
          vm.displayListLoaded = true;
          vm.appIsLoaded = true;
        });
    }
  }

  function _saveTicket() {
    return supportSharedModelService.saveTicket(vm.ticketCopy)
      .then((ticketId) => {
        alerts.success('Ticket saved successfully.');
        if (vm.ticketCopy.id === '') {
          vm.ticketCopy.id = ticketId;
        }
        angular.extend(vm.ticket, vm.ticketCopy);
      });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.editSupportTicketDialog);
  }
}

EditSupportTicketDialogController.$inject = [
  'ssDialogService',
  'alerts',
  'loaderService',
  'supportSharedModelService',
  'addSupportTicketAttachmentDialog',
  'addSupportTicketNoteDialog'
];
